import { Select } from 'antd';
import React from 'react';
import ChevronBottom from './ChevronBottom';
import Switch from './Switch';

const SwitchByExisting = ({ checked, onChange, onClick, label, fromValue, onSelect, placeholder, options }) => {
  return (
    <div className="mt-4">
      <Switch
        onClick={onClick}
        checked={checked}
        onChange={(checked) => onChange(checked)}
        label={label}
      />
      {checked && (
        <div className="mt-2">
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            value={fromValue}
            onSelect={onSelect}
            placeholder={placeholder}
            className="select-by-existing mt-5 w-1/2"
            suffixIcon={<ChevronBottom />}
          >
            {options}
          </Select>
        </div>
      )}
    </div>
  );
};

export default SwitchByExisting;
